import { handleError } from "../../../util/errors";
import apiBase from "../../api";

class UpdateCampaignsService {
  // Get all campaigns
  fetchCampaigns = async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.status) queryParams.append("status", params.status);
      if (params.page) queryParams.append("page", params.page);
      if (params.perPage) queryParams.append("perPage", params.perPage);

      const queryString = queryParams.toString();
      const url = `/update-campaigns${queryString ? `?${queryString}` : ""}`;
      const response = await apiBase.get(url);
      if (response.status !== 200) throw new Error();
      return response.data?.data || response.data;
    } catch (err) {
      throw handleError(err, "Error fetching update campaigns");
    }
  };

  // Get single campaign
  fetchCampaign = async (campaignId) => {
    try {
      const response = await apiBase.get(`/update-campaigns/${campaignId}`);
      if (response.status !== 200) throw new Error();
      return response.data?.data || response.data;
    } catch (err) {
      throw handleError(err, "Error fetching campaign");
    }
  };

  // Get devices in campaign
  fetchCampaignDevices = async (campaignId, params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.status) queryParams.append("status", params.status);
      if (params.page) queryParams.append("page", params.page);
      if (params.perPage) queryParams.append("perPage", params.perPage);

      const queryString = queryParams.toString();
      const url = `/update-campaigns/${campaignId}/devices${queryString ? `?${queryString}` : ""}`;
      const response = await apiBase.get(url);
      if (response.status !== 200) throw new Error();
      return response.data?.data || response.data;
    } catch (err) {
      throw handleError(err, "Error fetching campaign devices");
    }
  };

  // Create campaign
  createCampaign = async (data) => {
    try {
      const response = await apiBase.post("/update-campaigns", data);
      if (response.status !== 201 && response.status !== 200) throw new Error();
      return response.data?.data || response.data;
    } catch (err) {
      throw handleError(err, "Error creating campaign");
    }
  };

  // Start campaign
  startCampaign = async (campaignId) => {
    try {
      const response = await apiBase.post(`/update-campaigns/${campaignId}/start`);
      if (response.status !== 200) throw new Error();
      return response.data?.data || response.data;
    } catch (err) {
      throw handleError(err, "Error starting campaign");
    }
  };

  // Cancel campaign
  cancelCampaign = async (campaignId) => {
    try {
      const response = await apiBase.post(`/update-campaigns/${campaignId}/cancel`);
      if (response.status !== 200) throw new Error();
      return response.data?.data || response.data;
    } catch (err) {
      throw handleError(err, "Error cancelling campaign");
    }
  };

  // Refresh campaign (check for updated devices)
  refreshCampaign = async (campaignId) => {
    try {
      const response = await apiBase.post(`/update-campaigns/${campaignId}/refresh`);
      if (response.status !== 200) throw new Error();
      return response.data?.data || response.data;
    } catch (err) {
      throw handleError(err, "Error refreshing campaign");
    }
  };

  // Mark device as failed
  markDeviceFailed = async (campaignDeviceId, errorMessage) => {
    try {
      const response = await apiBase.post("/update-campaigns/device/mark-failed", {
        campaignDeviceId,
        errorMessage,
      });
      if (response.status !== 200) throw new Error();
      return response.data?.data || response.data;
    } catch (err) {
      throw handleError(err, "Error marking device as failed");
    }
  };
}

export default new UpdateCampaignsService();

